module.exports = __webpack_public_path__ + "static/media/ml.e6f097f9.svg";